import styled from "styled-components";
// 아이콘·제목·설명·목록을 가진 카드 3개
const TripleBox = ({ contents }) => {
  if (!contents || contents.length !== 3) return null;
  return (
    <Div>
      {contents.map((x, idx) => (
        <div key={idx}>
          <img src={x.icon} alt={x.alt ?? ""} />
          <span>{x.title}</span>
          {x.text && <div className="text">{x.text}</div>}
          {x.list && (
            <ul>
              {x.list.map((y, i) => {
                return <li key={i}>{y}</li>;
              })}
            </ul>
          )}
        </div>
      ))}
    </Div>
  );
};
export default TripleBox;
const Div = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
  & > div {
    padding: 2rem 1.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: ${({ theme }) => theme.radius};
    border: 1px solid ${({ theme }) => theme.colors.line};
    background-color: white;
    & > img {
      width: 4.5rem;
      height: 4.5rem;
      object-fit: contain;
    }
    & > span {
      font-size: 1.25rem;
      font-weight: 800;
      padding: 1.1rem 0 0.5rem;
      color: ${({ theme }) => theme.colors.dark};
      text-align: center;
    }
    & > .text {
      text-align: center;
      line-height: 1.7;
      color: ${({ theme }) => theme.colors.monotone.dark};
    }
    & > ul {
      width: 100%;
      margin: 0.75rem 0 0;
      padding: 1rem 0 0;
      list-style: none;
      border-top: 1px solid ${({ theme }) => theme.colors.line};
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      & > li {
        position: relative;
        padding-left: 1rem;
        line-height: 1.6;
        color: ${({ theme }) => theme.colors.monotone.dark};
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.65em;
          width: 0.35rem;
          height: 0.35rem;
          border-radius: 50%;
          background-color: ${({ theme }) => theme.colors.accent};
        }
      }
    }
  }
`;
